import React from 'react';

class Card extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {


    let award = this.props.award;

    let institution, article;

    institution = award.institution ?
      <h5 className="award-prize-institution">{ award.institution }</h5> : '';

    if(award.article) {
      article = <div className="award-article">
        <h5>
          <a href={ award.article.link }>
            { award.article.title }
          </a>
        </h5>
      </div>;
    }

    return (
      <div className="awards-card" id={ award.key }>
        <div className="award-prize">
          <h4 className="award-prize-name">
            { award.prize }
          </h4>
          { institution }
        </div>

        { article }
      </div>

    );
  }

}

export default Card;



// WEBPACK FOOTER //
// ./src/components/Jobs/Awards/Card.js